<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'AllowedUserContainer',
  props: {
    pageType: {
      type: String,
      required: true,
      validator: (value) => {
        return ['admin', 'writer'].indexOf(value) !== -1
      }
    }
  },
  computed: {
    ...mapState({
      siteUser: (state) => state.UserStore.currentUser
    })
  },
  watch: {
    siteUser () {
      this.$store.commit('errorPage/setForbidden', !this.permittedSiteAccess())
    }
  },
  mounted () {
    this.$store
      .dispatch('UserStore/fetchCurrentUser')
      .then(() => this.check() && this.fetchSiteReference())
  },
  methods: {
    fetchSiteReference () {
      const fetchProcesses = [
        this.$store.dispatch('SiteStore/fetchSiteReference'),
        this.$store.dispatch('I18n/fetchI18nTranslation')
      ]
      Promise.all(fetchProcesses)
    },
    check () {
      if (this.isClientInSitePage()) {
        this.$store.commit('errorPage/setForbidden', true)
        return false
      }
      if (!this.permittedSiteAccess()) {
        this.$store.commit('errorPage/setForbidden', true)
        return false
      }
      return true
    },
    isClientInSitePage () {
      return this.siteUser.isClient
    },
    permittedSiteAccess () {
      if (this.siteUser.isAdmin && this.pageType === 'admin') return true
      if (!this.siteUser.isAdmin && this.pageType === 'writer') return true

      return false
    }
  }
}
</script>
